import React from "react";
import { StyledTextButton } from "../../AddEditButton/styles";
import { v4 as uuidv4 } from "uuid";

interface Props {
  item: any;
  copyLogic?: any;
  saveCopiedItem: any;
  handleNotify: any;
  returnItem?: boolean;
  setLoading: (loading: boolean) => void;
  additionalActionsAfterCopy?: any;
}

export const CopyItem = ({
  item,
  copyLogic,
  saveCopiedItem,
  handleNotify,
  returnItem,
  setLoading,
  additionalActionsAfterCopy,
}: Props) => {
  const saveNewCopiedItem = async (item: any) => {
    setLoading(true);
    try {
      const modifiedItem = copyLogic ? await copyLogic(item) : { ...item, id: uuidv4() };

      const response = await saveCopiedItem(modifiedItem);

      if (!response.error) {
        !!additionalActionsAfterCopy && (await additionalActionsAfterCopy(modifiedItem, item));

        returnItem ? handleNotify(modifiedItem) : handleNotify();
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  return <StyledTextButton onClick={() => saveNewCopiedItem(item)}>{"Copy"}</StyledTextButton>;
};
